import { render, staticRenderFns } from "./PaginatedTable.vue?vue&type=template&id=6a27d54f"
import script from "./PaginatedTable.vue?vue&type=script&lang=ts"
export * from "./PaginatedTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports